import { useEffect, useState } from "react";

import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx"
import { autoFillDates } from "../../utils/autoFillDates.jsx"
import { autoFillMEC } from "../../utils/autoFillMEC.jsx";
import { useMediaQuery } from 'react-responsive';
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx";
import InfoSVG from "../../assets/InfoSVG.jsx";
import InfoModal from '../InfoModal.jsx'; 

import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import MainDatesSection from "./MainDatesSection.jsx";

import SaveButton from "../SaveButton.jsx";
import PDFPreview  from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";
import MainCard from "../MainCard.jsx";

const DatesDeadlines = () => {
    const { handleNext, handleBack } = useStepContext();
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); 
    const { formData, setFormData, formId, handleDateInputChange, handleClosingDateChange, handleClosingCostChange, handleAdditionalDatesChange } = useFormContext(); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { token, user } = useAuth(); // Use user and token from context
    const [ isAssistVisible, setIsAssistVisible ] = useState(false);

    const currentPageValue = 1;
    const currentSubStepProgress = 1/3;

    const normalizedTitle = 'acceptance_deadline_date';
    
    const handleDateFieldInputChange = (event) => {
        const value = event.target.value; 
        // const isFilled = value !== '';
        // handleFillField(isFilled);
        
        handleDateInputChange({
            target: {
                name: normalizedTitle, 
                value: value
            }
        })
    };

    const handleInfoClick = () => {
        setIsInfoModalOpen(true); 
        // dateContent; 
    }; 

    const handleCloseInfoModal = () => {
        setIsInfoModalOpen(false); 
    }

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    // useEffect(() => {
    //     if (formData.dateFields.closingTimeframe === '30 days') {
    //         autoFillDates(30, formData, setFormData);
    //     } else if (formData.dateFields.closingTimeframe === '45 days') {
    //         autoFillDates(45, formData, setFormData);
    //     } else if (formData.dateFields.closingTimeframe === '60 days') {
    //         autoFillDates(60, formData, setFormData);
    //     } else if (formData.dateFields.closingTimeframe === 'manual') {
    //     }
    useEffect(() => {
        if (formData.dateFields.closingTimeframe === '30 days') {
            autoFillMEC(30, formData, setFormData);
        } else if (formData.dateFields.closingTimeframe === '45 days') {
            autoFillMEC(45, formData, setFormData);
        } else if (formData.dateFields.closingTimeframe === '60 days') {
            autoFillMEC(60, formData, setFormData);
        } else if (formData.dateFields.closingTimeframe === 'manual') {
        }
    }, [formData.dateFields.closingTimeframe, formData.dateFields.acceptance_deadline_date.date, formData.addWaterAndMineralDates, formData.isHOA]);

    function clearDates() {
        const newDateFields = { ...formData.dateFields };
    
        for (const field in newDateFields) {
            if (newDateFields[field] && typeof newDateFields[field] === 'object') {
                newDateFields[field].date = '';
                newDateFields[field].daysFromMEC = '';
                newDateFields[field].dayOfWeek = ''; // clear dayOfWeek
            }
        }
    
        setFormData(prevState => ({
            ...prevState,
            isHOA: null,
            addWaterAndMineralDates: null,
            // dateFields: newDateFields,
            dateFields: {
                // ...prevState.dateFields,
                ...newDateFields,
                association_document_deadline: {
                    "date": "N/A",
                    'dayOfWeek': '',
                    'daysFromMEC': 'N/A',
                    "checked": false,
                    "scheduledWithVendor": false
                },
                  association_documents_termination_deadline: {
                    "date": "N/A",
                    'dayOfWeek': '',
                    'daysFromMEC': 'N/A',
                    "checked": false,
                    "scheduledWithVendor": false
                },
                // loan_transfer_approval_deadline: {
                //     "date": "N/A",
                //     'dayOfWeek': '',
                //     'daysFromMEC': 'N/A',
                //     "checked": false,
                //     "scheduledWithVendor": false
                // },
                //   seller_or_private_financing_deadline: {
                //     "date": "N/A",
                //     'dayOfWeek': '',
                //     'daysFromMEC': 'N/A',
                //     "checked": false,
                //     "scheduledWithVendor": false
                // },
                water_rights_examination_deadline: {
                    "date": "N/A",
                    'dayOfWeek': '',
                    'daysFromMEC': 'N/A',
                    "checked": false,
                    "scheduledWithVendor": false
                },
                  mineral_rights_examination_deadline: {
                    "date": "N/A",
                    'dayOfWeek': '',
                    'daysFromMEC': 'N/A',
                    "checked": false,
                    "scheduledWithVendor": false
                },
                closingTimeframe: '', // clear closingTimeframe
            },
        }));
    }


    // SECTION DATA
    const sectionsData = [
        {
            title: "GENERAL",
            subSections: [
                { title: "Time Deadline to Send Contract", dateField: formData?.dateFields?.timeDeadlineToSendContract?.date, inputType: 'time' },
                { title: "Alternative Earnest Money Deadline", dateField: formData?.dateFields?.alternativeEarnestMoneyDeadline?.daysFromMEC }
            ]
        }, 
        {
            title: "TITLE", 
            subSections: [
                { title: "Record Title Deadline", dateField: formData?.dateFields?.RecordTitleDeadline?.daysFromMEC },
                { title: "Record Title Objection Deadline", dateField: formData?.dateFields?.RecordTitleObjectionDeadline?.daysFromMEC },
                { title: "Off Record Title Deadline", dateField: formData?.dateFields?.OffRecordTitleDeadline?.daysFromMEC },
                { title: "Off Record Title Objection Deadline", dateField: formData?.dateFields?.OffRecordTitleObjectionDeadline?.daysFromMEC },
                { title: "Title Resolution Deadline", dateField: formData?.dateFields?.TitleResolutionDeadline?.daysFromMEC },
                { title: "Right of First Refusal Deadline", dateField: formData?.dateFields?.RightOfFirstRefusalDeadline?.daysFromMEC }
            ]
        },
        {
            title: "OWNERS ASSOCIATION",
            subSections: [
                { title: "Association Document Deadline", dateField: formData?.dateFields?.AssociationDocumentDeadline?.daysFromMEC }, 
                { title: "Association Documents Termination Deadline", dateField: formData?.dateFields?.AssociationDocumentsTerminationDeadline?.daysFromMEC }
            ]
        },
        {
            title: "SELLERS DISCLOSURES", 
            subSections: [
                { title: "Seller Property Disclosure Deadline", dateField: formData?.dateFields?.SellerPropertyDisclosureDeadline?.daysFromMEC },
                { title: "Lead Based Paint Disclosure Deadline", dateField: formData?.dateFields?.LeadBasedPaintDisclosureDeadline?.daysFromMEC },
            ]
        },
        {
            title: "LOAN & CREDIT",
            subSections: [
                { title: "New Loan Application Deadline", dateField: formData?.dateFields?.NewLoanApplicationDeadline?.daysFromMEC },
                { title: "New Loan Terms or Termination Deadline", dateField: formData?.dateFields?.NewLoanTermsOrTerminationDeadline?.daysFromMEC },
                { title: "New Loan Availability Deadline", dateField: formData?.dateFields?.NewLoanAvailabilityDeadline?.daysFromMEC },
                { title: "Buyers Credit Information Deadline", dateField: formData?.dateFields?.BuyersCreditInformationDeadline?.daysFromMEC },
                { title: "Disapproval of Buyers Credit Information Deadline", dateField: formData?.dateFields?.DisapprovalOfBuyersCreditInformationDeadline?.daysFromMEC },
                { title: "Existing Loan Deadline", dateField: formData?.dateFields?.ExistingLoanDeadline?.daysFromMEC },
                { title: "Existing Loan Termination Deadline",dateField: formData?.dateFields?.ExistingLoanTerminationDeadline?.daysFromMEC },
                { title: "Loan Transfer Approval Deadline", dateField: formData?.dateFields?.LoanTransferApprovalDeadline?.daysFromMEC },
                { title: "Seller or Private Financing Deadline", dateField: formData?.dateFields?.SellerOrPrivateFinancingDeadline?.daysFromMEC }
            ]
        },
        {
            title: "APPRAISAL",
            subSections: [
                { title: "Appraisal Deadline", dateField: formData?.dateFields?.AppraisalDeadline?.daysFromMEC },
                { title: "Appraisal Objection Deadline", dateField: formData?.dateFields?.AppraisalObjectionDeadline?.daysFromMEC },
                { title: "Appraisal Resolution Deadline", dateField: formData?.dateFields?.AppraisalResolutionDeadline?.daysFromMEC },
            ]
        },
        {
            title: "SURVEY",
            subSections: [
                { title: "New ILC or New Survey Deadline", dateField: formData?.dateFields?.NewIlcOrNewSurveyDeadline?.daysFromMEC },
                { title: "New ILC or New Survey Objection Deadline", dateField: formData?.dateFields?.NewIlcOrNewSurveyObjectionDeadline?.daysFromMEC },
                { title: "New ILC or New Survey Resolution Deadline", dateField: formData?.dateFields?.NewIlcOrNewSurveyResolutionDeadline?.daysFromMEC }
            ]
        },
        { 
            title: "INSPECTION & DUE DILIGENCE",
            subSections: [
                { title: "Water Rights Examination Deadline", dateField: formData?.dateFields?.WaterRightsExaminationDeadline?.daysFromMEC },
                { title: "Mineral Rights Examination Deadline", dateField: formData?.dateFields?.MineralRightsExaminationDeadline?.daysFromMEC },
                { title: "Inspection Termination Deadline", dateField: formData?.dateFields?.InspectionTerminationDeadline?.daysFromMEC },
                { title: "Inspection Objection Deadline", dateField: formData?.dateFields?.InspectionObjectionDeadline?.daysFromMEC },
                { title: "Inspection Resolution Deadline", dateField: formData?.dateFields?.InspectionResolutionDeadline?.daysFromMEC },
                { title: "Property Insurance Termination Deadline", dateField: formData?.dateFields?.PropertyInsuranceTerminationDeadline?.daysFromMEC },
                { title: "Due Diligence Documents Delivery Deadline", dateField: formData?.dateFields?.DueDiligenceDocumentsDeliveryDeadline?.daysFromMEC },
                { title: "Due Diligence Documents Objection Deadline", dateField: formData?.dateFields?.DueDiligenceDocumentsObjectionDeadline?.daysFromMEC },
                { title: "Due Diligence Documents Resolution Deadline", dateField: formData?.dateFields?.DueDiligenceDocumentsResolutionDeadline?.daysFromMEC },
                { title: "Conditional Sale Deadline", dateField: formData?.dateFields?.ConditionalSaleDeadline?.daysFromMEC },
                { title: "Lead Based Paint Termination Deadline", dateField: formData?.dateFields?.LeadBasedPaintTerminationDeadline?.daysFromMEC },
                { title: "Closing Date", dateField: formData?.dateFields?.ClosingDate?.daysFromMEC },
                { title: "Possession Date", dateField: formData?.dateFields?.PossessionDate?.daysFromMEC },
                { title: "Possession Time", dateField: formData?.dateFields?.PossessionTime?.date, inputType: 'time' },
                { title: "Acceptance Deadline Date", dateField: formData?.dateFields?.AcceptanceDeadlineDate?.daysFromMEC },
                { title: "Acceptance Deadline Time", dateField: formData?.dateFields?.AcceptanceDeadlineTime?.date, inputType: 'time' }
            ]
        }
    ]; 

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
            {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
            <MainCard width={750} gap={0}>
            <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
                <div className="flex-col justify-start w-full">
                    <div className='inline-flex justify-between items-center w-full mb-5'>
                        {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Dates & deadlines</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Dates & deadlines</h3>}
                        <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                            <HelpButton onClick={toggleAssist}/>
                            <SaveButton formData={formData} formId={formId}/>
                            {user && <PDFPreview formData={formData}/>}
                        </div>
                    </div>
            
            <div className={`h-auto w-full mb-6 mt-2 justify-between align-left items-center border border-slate-200 bg-white p-4 shadow-md rounded-lg ${isMobile ? 'flex flex-col gap-3' : 'inline-flex'} `}>
                <div className="flex flex-col">
                    <div className="inline-flex gap-4 mb-4">
                        <span className="font-[Inter] font-bold w-auto text-[18px] md:text-[18px]">Mutually Executed Contract Date (MEC)</span>
                        <InfoSVG onClick={handleInfoClick} width={24} height={24}/>
                    </div>
                    <div className="border-blue-500 bg-blue-50 border rounded-md md:p-2 p-1 inline-flex justify-between w-full gap-2 mb-4 items-start">
                        {isMobile ? <InfoSVG width={18} height={18} fill='#2563EB'/> : <InfoSVG width={23} height={23} fill='#2563EB'/>}
                        <div className="flex-col gap-2">
                        <span className="text-blue-800 text-[13px] w-full">All dates are editable. Most dates are based on the Mutually Executed Contract date, which is the date ALL parties have signed the contract.<b><i> Verify the date during and after the contract is signed.</i></b><br></br></span>
                        <span><br></br></span>
                        <span className="text-blue-800 text-[13px] w-full">Dates cannot fall on a federal holiday or weekend and will be counted from the first day after the MEC. E.g. if the contract is signed on a Monday and the date is 3 days from MEC then the first day would be Tuesday with the final day falling on Thursday.</span>
                        </div>
                    </div>
                    {/* <div className="border-blue-500 bg-blue-50 border rounded-md md:p-2 p-1 inline-flex justify-between w-full gap-2 mb-4 items-center">
                        {isMobile ? <InfoSVG width={18} height={18} fill='#3B82F6'/> : <InfoSVG width={23} height={23} fill='#3B82F6'/>}
                        <span className="text-blue-800 text-[13px] w-full">If the date falls on a weekend or holiday it will move to the next non <u>Federal</u> holiday weekday. Dates will be counted from the first day after the MEC. E.g. if the contract is signed on a Monday and the date is 3 days from MEC then the first day would be Tuesday with the final day falling on Thursday.</span>
                    </div> */}
                </div>
            </div>

        {/* {formData.dateFields[normalizedTitle]?.date && ( */}
            <div className="flex flex-col w-full items-start align-left">
            <span className="text-sm text-slate-600 mb-4">(OPTIONAL) Other Dates</span>
            
            {/* HOA SECTION */}
            <div className="align-left items-start flex flex-col mb-2">
                <span className="w-auto text-[14px] md:text-[16px] font-inter">Add dates for Home Owner's Association?</span>
                <div className="mb-2 inline-flex w-full gap-6">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                            value='yes'
                            checked={formData.isHOA === true} 
                            onChange={() => handleAdditionalDatesChange('isHOA', true)}
                        />
                        <label className="text-black">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                            value='no'
                            checked={formData.isHOA === false} 
                            onChange={() => handleAdditionalDatesChange('isHOA', false)}
                        />
                        <label className="text-black">No</label>
                    </div>
                </div>
            </div>

                

                {/* WATER/MINERAL SECTION */}
                <div className=" align-left items-start flex flex-col mt-2 mb-4">
                <span className="w-auto text-[14px] md:text-[16px] font-inter">Add dates for Water & Mineral rights?</span>
                    <div className="mb-2 inline-flex w-full gap-6">
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                                value='yes'
                                checked={formData.addWaterAndMineralDates === true} 
                                onChange={() => handleAdditionalDatesChange('addWaterAndMineralDates', true)}
                            />
                            <label className="text-black">Yes</label>
                        </div>
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                                value='no'
                                checked={formData.addWaterAndMineralDates === false} 
                                onChange={() => handleAdditionalDatesChange('addWaterAndMineralDates', false)}
                            />
                            <label className="text-black">No</label>
                        </div>
                    </div>
                </div>

                <div className="w-full align-left items-start flex flex-col mt-3 mb-4">
                <div className="flex flex-col gap-1">
                        <span className="w-auto text-slate-600 text-sm font-inter mb-1">(OPTIONAL) Auto fill with a closing timeframe</span>
                        <span className="w-auto text-slate-600 text-sm font-inter mb-2">Note: All dates can be adjusted manually, even after auto filling</span>
                    {/* <span className="font-[Inter] text-shi-purple w-full text-[14px] md:text-[14px]"><b>Note:</b> You can edit dates even after auto-filling</span> */}
                </div>
                <div className={` ${isMobile ? 'flex flex-col w-full gap-2' : 'inline-flex w-full'} mb-2 gap-6`}>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="checkbox" 
                            className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                            value={formData.dateFields.closingTimeframe}
                            checked={formData.dateFields.closingTimeframe === '30 days'} 
                            onChange={(e) => {
                                handleClosingDateChange('closingTimeframe', e.target.checked ? '30 days' : 'no'); 
                            }}
                        />
                        <label className="text-black">30 Day</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="checkbox" 
                            className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                            value={formData.dateFields.closingTimeframe}
                            checked={formData.dateFields.closingTimeframe === '45 days'} 
                            onChange={(e) => {
                                handleClosingDateChange('closingTimeframe', e.target.checked ? '45 days' : 'no'); 
                            }}
                        />
                        <label className="text-black">45 Day</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="checkbox" 
                            className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                            value={formData.dateFields.closingTimeframe}
                            checked={formData.dateFields.closingTimeframe === '60 days'} 
                            onChange={(e) => {
                                handleClosingDateChange('closingTimeframe', e.target.checked ? '60 days' : 'no'); 
                            }}
                        />
                        <label className="text-black">60 Day</label>
                    </div>
                    {/* <div className="items-center gap-2 flex">
                        <input 
                            type="checkbox" 
                            className={`w-auto h-auto bg-green-100 border p-2 border-slate-100 rounded-md text-white}`} 
                            value={formData.dateFields.closingTimeframe}
                            checked={formData.dateFields.closingTimeframe === 'manual'} 
                            onChange={(e) => handleClosingDateChange('closingTimeframe', e.target.checked ? 'manual' : 'no')}
                        />
                        <label className="text-black">Manual</label>
                    </div> */}

                    <div className="">
                        <button 
                            className={`w-auto h-auto border px-2 py-1 border-slate-600 text-[12px] md:text-[14px] rounded-md text-black hover:bg-slate-300 bg-white}`} 
                            onClick={clearDates}
                        >
                        Reset
                        </button>
                    </div>
                </div>
            </div>
            
        </div>
        </div>
            <div className="w-full h-[400px] md:h-[525px] rounded-lg flex-col justify-start items-start inline-flex overflow-hidden" style={{ overflowY: 'auto' }}>                        
                <MainDatesSection
                    sectionsData={sectionsData}
                    formData={formData}
                />
            </div>
            </div>
            <div className="flex w-full justify-center gap-10 md:gap-36 bg-white">
                        <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                            Back
                        </button>
                        <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                            Next
                        </button>
                    </div>
            </MainCard>
            {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
            
            <InfoModal isOpen={isInfoModalOpen} onClose={handleCloseInfoModal}>
                <div>
                    <h1 className="text-shi-green text-[16px] w-full flex md:text-2xl font-bold mb-1 md:mb-4 items-center justify-center">What is the MEC</h1>
                    {isMobile ? '' : <hr className="my-4" />}
                    <div className="flex flex-col gap-2 ">
                        <p className="text-[14px] w-full md:text-[16px]"><b>Definition</b> <br />The date when all parties have signed the contract, making it fully executed.</p>
                        <p className="text-[14px] w-full md:text-[16px]"><b>How it affects your transaction</b> <br />Contract deadlines are calculated from this date. Look for the info icons next to each deadline in the contract to see how many days should be added to the MEC date, based on a 30 day closing timeframe.</p>
                        <p className="text-[14px] w-full md:text-[16px]"><b>Important Notes</b> 
                            <br/><br/>- The MEC date can be the same day as contract submission if all parties sign that day
                            <br/><br/>- If signed after the Acceptance Deadline, the seller must issue a counter proposal
                        </p>
                    </div>
                </div>
            </InfoModal>
        </div>
    ); 
}; 

export default DatesDeadlines;